/**
 * Maestro de concesionarias (2026-10-07). Las actas de cocina las eligen al
 * iniciar; no se borran, se desactivan (las actas viejas las nombran).
 */
import {
  rec_Bo as claseFila,
  rec_EstadoError as EstadoError,
  rec_Lo as claseEntrada,
  rec_React as React,
  rec_api as api,
  rec_zo as claseBoton,
} from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useCallback = (...a) => React.useCallback(...a);
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

function Formulario({ inicial, onGuardado, onCancelar }) {
  const [nombre, setNombre] = useState(inicial?.nombre ?? ``);
  const [ruc, setRuc] = useState(inicial?.ruc ?? ``);
  const [error, setError] = useState(``);
  const [guardando, setGuardando] = useState(false);
  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true); setError(``);
    try {
      const body = JSON.stringify({ nombre, ruc, activo: inicial?.activo ?? true });
      if (inicial?.id) await api(`/concesionarias/${inicial.id}`, { method: `PUT`, body });
      else await api(`/concesionarias`, { method: `POST`, body });
      onGuardado();
    } catch (err) { setError(err.message); setGuardando(false); }
  };
  return (
    <form onSubmit={guardar} className={`${claseFila} flex flex-col gap-2`}>
      <div className="flex flex-wrap gap-2">
        <input className={`${claseEntrada} flex-1`} style={{ minWidth: 220 }} autoFocus placeholder="Razón social" aria-label="Razón social"
          maxLength={160} value={nombre} onChange={(e) => setNombre(e.target.value)} />
        <input className={claseEntrada} style={{ width: 160 }} placeholder="RUC (opcional)" aria-label="RUC" inputMode="numeric"
          maxLength={11} value={ruc} onChange={(e) => setRuc(e.target.value.replace(/\D/g, ``))} />
      </div>
      {error && <p className="text-xs text-(--error-texto)" role="alert">{error}</p>}
      <div className="flex justify-end gap-2">
        <button type="button" className={claseBoton} onClick={onCancelar}>Cancelar</button>
        <button type="submit" className={claseBoton} disabled={guardando || !nombre.trim()}>{inicial?.id ? `Guardar` : `Agregar`}</button>
      </div>
    </form>
  );
}

export function Concesionarias() {
  const [lista, setLista] = useState(null);
  const [error, setError] = useState(``);
  const [editando, setEditando] = useState(null);
  const cargar = useCallback(async () => {
    try { setLista(await api(`/concesionarias?todos=true`)); setError(``); } catch (e) { setError(e.message); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);
  const alternar = async (c) => {
    try {
      await api(`/concesionarias/${c.id}`, { method: `PUT`, body: JSON.stringify({ nombre: c.nombre, ruc: c.ruc, activo: !c.activo }) });
      cargar();
    } catch (e) { setError(e.message); }
  };
  return (
    <div className="flex flex-col gap-3">
      <EstadoError mensaje={error} onReintentar={cargar} />
      <p className="text-sm text-(--text)">Las empresas que atienden los comedores. Se eligen al iniciar las actas de cocina y cada una puede tener su usuario para levantar sus observaciones.</p>
      <div className="flex justify-end">
        <button type="button" className={claseBoton} onClick={() => setEditando({})}>+ Nueva concesionaria</button>
      </div>
      {editando && !editando.id && <Formulario inicial={null} onCancelar={() => setEditando(null)} onGuardado={() => { setEditando(null); cargar(); }} />}
      {!lista ? <p className="text-sm text-(--text)">Cargando…</p> : lista.length === 0 ? (
        <p className="text-sm text-(--text)">Todavía no hay concesionarias.</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {lista.map((c) => editando?.id === c.id ? (
            <li key={c.id}><Formulario inicial={c} onCancelar={() => setEditando(null)} onGuardado={() => { setEditando(null); cargar(); }} /></li>
          ) : (
            <li key={c.id} className={`${claseFila} flex items-center gap-3`}>
              <span className="flex-1 text-sm text-(--text-h)">{c.nombre}{c.ruc && <span className="text-xs text-(--text)"> · RUC {c.ruc}</span>}</span>
              {!c.activo && <span className="rounded-full bg-(--panel) px-2 py-0.5 text-[10px] uppercase text-(--text)">inactiva</span>}
              <button type="button" className="rounded-lg px-2 py-2 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)" onClick={() => setEditando(c)}>Editar</button>
              <button type="button" className="rounded-lg px-2 py-2 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)" onClick={() => alternar(c)}>{c.activo ? `Desactivar` : `Activar`}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
